import { DateTime } from "luxon";

/**
 * Converts a UTC Date object or ISO string into Newfoundland-local date parts
 * (year, month, day). Useful for pre-filling calendar components.
 *
 * @param {Date | string} utcDate - The UTC date input
 * @returns {{ year: number, month: number, day: number } | null}
 */
export const getNewfoundlandDateParts = (utcDate) => {
  if (!utcDate) return null;

  const dt = DateTime.fromJSDate(new Date(utcDate), { zone: "utc" }).setZone(
    "America/St_Johns"
  );

  if (!dt.isValid) return null;

  return {
    year: dt.year,
    month: dt.month, // 1-based
    day: dt.day,
  };
};
